import React from 'react';
import { I18n } from 'aws-amplify';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import { MAX_CRUISE_SCREEN_TITLE_NUM } from '../../../configures/val.js';
import countSurrogateStr from '../../util/countSurrogateStr.js';

export default class CruiseSettingBlockMaker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorScreenClass: 'mypageOkText',
      title: this.props.setting.title
    };
  }
  handleChange = (event) => {
    const {value, name} = event.target;
    if (value.length <= 0) {
      this.setState({
        errorScreenClass: 'mypageErrorText',
        title: value
      });
      this.props.updatePostCruiseSetting(name, value);
      return;
    } else if (value.length > MAX_CRUISE_SCREEN_TITLE_NUM) {
        const srrStrNum = countSurrogateStr(value);
        if (srrStrNum > MAX_CRUISE_SCREEN_TITLE_NUM) {
          this.setState({
            errorScreenClass: 'mypageErrorText',
            title: value
          });
          this.props.updatePostCruiseSetting(name, value);
          return;
        }
    }
    this.props.updatePostCruiseSetting(name, value);
    this.setState({
      errorScreenClass: 'mypageOkText',
      title: value
    });
  }
  showTitle = () => {
    const nameStr = 'mierukaCruiseSetting-' + this.props.setting.asset.screenId;
    const idStr = 'mierukaCruiseSettingBlockId' + this.props.idx;
    const clsStr = 'cruiseSettingBlockMaker ' + this.state.errorScreenClass;
    let errorScreenNameStr = I18n.get('The title can be up to ');
    errorScreenNameStr += MAX_CRUISE_SCREEN_TITLE_NUM;
    errorScreenNameStr += I18n.get(' characters.');
    if (this.props.setting.hasOwnProperty('editable')) {
      if (!this.props.isPremium && this.props.setting.editable.title) {
        return (
          <div>
            <input className='mierukaInputStyle large' name={nameStr} id={idStr} type='text' value ={this.state.title} placeholder={I18n.get('Enter your plant name.')} onChange={this.handleChange} />
            <span className="changeableIcon fontSizeSmall">{I18n.get('EDITABLE')}</span>
            <p className={clsStr}>{errorScreenNameStr}</p>
          </div>
        );
      } else {
        return (
          <p className="marLeft25">{this.props.setting.title}</p>
        );
      }
    } else {
      return (
        <p className="marLeft25">{this.props.setting.title}</p>
      );
    }
  }
  render() {
    return (
      <div className='mierukaInputFlex'>
        <dt>
          <Typography variant='subheading' gutterBottom>
            {I18n.get('Screen ')}{this.props.idx}
          </Typography>
        </dt>
        <dd>
          <span className='testStyle'>
            <button onClick={() => this.props.openCarousel(this.props.idx - 1)}><img alt='img' className='mierukaThumbnail' src={this.props.imgsrc} /></button>
          </span>
          <span>
            {// キー読んで、そのキーに該当する要素をなにかする
            }
            <FormControl>
              {this.showTitle()}
            </FormControl>
          </span>
        </dd>
      </div>
    );
  }
}
